"use client";

import React, { useEffect, useRef, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
type UseRevealOnScrollOptions = {
  once?: boolean;
  threshold?: number | number[];
  rootMargin?: string;
};
function useRevealOnScroll<T extends HTMLElement = HTMLElement>({
  once = true,
  threshold = 0.1,
  rootMargin = "0px"
}: UseRevealOnScrollOptions = {}) {
  const ref = useRef<T | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        setIsVisible(true);
        if (once) {
          observer.unobserve(entry.target);
        }
      } else if (!once) {
        setIsVisible(false);
      }
    }, {
      threshold,
      rootMargin
    });
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [once, rootMargin, threshold]);
  return {
    ref,
    isVisible
  };
}
const categories = ["Összes", "Szállás", "Repülő", "Taxi"];
const projects = [{
  id: 1,
  title: "Maldív-szigetek",
  category: "Szállás",
  client: "Luxus Resort",
  year: "4.9 ",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/destination_maldives.png",
  aspectClass: "aspect-[3/4]"
}, {
  id: 2,
  title: "New York City",
  category: "Repülő",
  client: "Direct Flight",
  year: "5.0 ",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/destination_nyc.png",
  aspectClass: "aspect-square"
}, {
  id: 3,
  title: "Római Transzfer",
  category: "Taxi",
  client: "Premium Taxi",
  year: "4.8 ",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/destination_rome.png",
  aspectClass: "aspect-[4/3]"
}, {
  id: 4,
  title: "Svájci Alpok",
  category: "Szállás",
  client: "Chalet Stay",
  year: "4.9 ",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/destination_alps.png",
  aspectClass: "aspect-[3/4]"
}, {
  id: 5,
  title: "Tokiói Kaland",
  category: "Repülő",
  client: "Global Air",
  year: "4.7 ",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/destination_tokyo.png",
  aspectClass: "aspect-square"
}, {
  id: 6,
  title: "Párizsi Éjszaka",
  category: "Taxi",
  client: "City Cab",
  year: "4.6 ",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/destination_paris.png",
  aspectClass: "aspect-[4/3]"
}];
export default function Portfolio() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.05
  });
  return;
}